import AppConstants from '../config/app.constants';

let UserBranchService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/user-branch`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getUserBranches = (userId) => {
        let query = '';
        if (userId) {
            query = `?user=${userId}`
        }
        return $http
            .get(AppConstants.api + `/user-branch/getBranchGroup` + query)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        getUserBranches
    };

};

UserBranchService.$inject = ['$http', '$q']

export default UserBranchService;


// WEBPACK FOOTER //
// ./client/app/services/user-branch.service.js